document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.slider');
    sliders.forEach((slider) => {
        const emblaNode: HTMLElement = slider as HTMLElement;

        const navContainer = emblaNode.querySelector('.slider__nav') as HTMLElement;
        const scrollbarTrack = navContainer?.querySelector('.slider__scrollbar') as HTMLElement;
        const scrollbarThumb = navContainer?.querySelector('.slider__scrollbar-thumb') as HTMLElement;

        // Embla Optionen (analog zum React Code)
        const options = {
            align: 'start',
            containScroll: 'trimSnaps'
        };

        // Embla initialisieren
        // "EmblaCarousel" ist durch das CDN Skript global verfügbar
        const emblaApi = EmblaCarousel(emblaNode, options);

        // Funktion zum Aktualisieren der Pfeil-Sichtbarkeit
        const updateArrows = () => {
            const canScrollPrev = emblaApi.canScrollPrev();
            const canScrollNext = emblaApi.canScrollNext();

            if (!canScrollPrev && !canScrollNext) {
                navContainer.style.display = 'none';
            } else {
                navContainer.style.display = 'flex';
            }
        };

        const updateScrollbar = () => {
            if (!scrollbarTrack || !scrollbarThumb) return;

            const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
            const maxTranslate = scrollbarTrack.clientWidth - scrollbarThumb.clientWidth;

            scrollbarThumb.style.transform = `translate3d(${progress * maxTranslate}px, 0px, 0px)`;
        };

        emblaApi.on('init', () => {
            updateArrows();
            updateScrollbar();
        });

        emblaApi.on('reInit', () => {
            updateArrows();
            updateScrollbar();
        });

        // Das wichtigste Event für die Scrollbar:
        emblaApi.on('scroll', updateScrollbar);
    })
});